let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2OEvS")).then(() => parcelRequire('dUmfz'));